import React, {useEffect, useState,} from 'react';
import styles from './memberRuleDialog.module.scss';
import {Mask} from "antd-mobile";
import Services from "../../../../services";
import {isEmptyString} from "../../../../library/util";


export const MemberRuleDialog = ({maskVisible, setMaskVisible}) => { //会员规则

    const [title, setRuleTitle] = useState();
    const [content, setRuleContent] = useState();
    const btnClick = () => {
        setMaskVisible(!maskVisible);
    }

    useEffect(() => {
        maskVisible && getProtocol();
    }, [maskVisible]);
    const getProtocol = async () => { //获取协议
        const res = await Services('MainPage', {code: '101193'}, {
            codeType: 'activityRule',
            activityCode: 'CR2023',
            code: 'apeWorldInviteRule',
        })
        if (res.status > 0) {
            const {data} = res
            setRuleTitle(data.activityRule.codeAlias)
            let otherSign = data.activityRule.otherSign;
            if (!isEmptyString(otherSign)) {
                setRuleContent(otherSign)
            }
        }
    }

    return (
        <Mask visible={maskVisible} opacity={0.8}>
            <div className={styles.share_container}>
                <div className={styles.share_container_content}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.content}>{content}</div>
                    <div className={styles.sure_btn} onClick={() => btnClick()}>我知道了</div>
                </div>
            </div>
        </Mask>
    )

}
